import styled from "styled-components";

export const SelectContractTypeButtonContainer = styled.button`
	background: transparent;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 8px;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	padding: 32px;
	min-height: 284px;
`;

export const IconContainer = styled.div`
	padding: 16px;
	background-color: #eef2ff;
	border-radius: 8px;
`;

export const SelectContractTypeButtonTitle = styled.h3`
	font-size: 20px;
	font-weight: 700;
	color: #31475a;
	text-align: center;
	margin-top: 10px;
`;

export const SelectContractTypeButtonDescription = styled.p`
	font-size: 16px;
	color: #31475a;
	text-align: center;
	margin-top: 10px;
`;
